import InvestorService from "@/services/v2/bytepro/investor.service";

export const investorApiV2 = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getInvestors({ commit }) {
      return InvestorService.getInvestors().then(
        (resp) => {
          commit("dummyConsole", "InvestorService.getInvestors - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "InvestorService.getInvestors - error");
          return Promise.reject(error);
        }
      );
    },
    getInvestor({ commit }, investorId) {
      return InvestorService.getInvestor(investorId).then(
        (resp) => {
          commit("dummyConsole", "InvestorService.getInvestor - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "InvestorService.getInvestor - error");
          return Promise.reject(error);
        }
      );
    },
    getInvestorsWithImLoanProgram({ commit }) {
      return InvestorService.getInvestorsWithImLoanProgram().then(
        (resp) => {
          commit(
            "dummyConsole",
            "InvestorService.getInvestorsWithImLoanProgram - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "InvestorService.getInvestorsWithImLoanProgram - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
